import React from "react";
import MenuItem from "./MenuItem";
import GetUser from "../../../utils/UserFunctions/GetUser";
import injectSheet from "react-jss";
import { ListType, ViewType } from "../../../utils/Enums";
import styles from "./NavMenusStyles"; // Import styles
function Statusmenu(props) {
  const allViews = GetUser().allViews;
  const views = allViews.filter(
    (view) =>
      view === ViewType.VisaPågående ||
      view === ViewType.VisaArkiverade ||
      view === ViewType.VisaGodkända ||
      view === ViewType.VisaSlutförda
  );

  let userViews = [...views];
  if (!allViews.find((view) => view === ViewType.AttGodkänna))
    userViews = userViews.filter((x) => x !== ViewType.VisaGodkända);

  const showSamv =
    !GetUser().visaEjSamvArr &&
    allViews.filter(
      (view) =>
        view === ViewType.EjInskickade ||
        view === ViewType.NekadeSomSkaKompletteras ||
        view === -ViewType.InskickadeSomSkaGodkännas
    ).length > 0;
  const showAvd =
    allViews.filter(
      (view) =>
        view === ViewType.AttGodkänna ||
        view === ViewType.AttStarta ||
        view === ViewType.AttSlutrapportera ||
        view === ViewType.AttKontrollera
    ).length > 0;

  const { classes } = props;
  return (
    <div className={classes.navmenu}>
      {props.hideHeader ? null : <h2>Visa</h2>}
      <h4>Mina arrangemang</h4>
      <ul>
        {userViews.map((view, index) => (
          <MenuItem
            toggleMobileMenu={props.toggleMobileMenu}
            toggleSubmenu={props.toggleSubmenu}
            view={view}
            listtype={ListType.User}
            key={index}
          />
        ))}
      </ul>
      {showSamv && (
        <>
          <h4>Mina organisationers arrangemang</h4>
          <ul>
            {views.map((view, index) => (
              <MenuItem
                toggleMobileMenu={props.toggleMobileMenu}
                toggleSubmenu={props.toggleSubmenu}
                view={view}
                listtype={ListType.Samverkanspart}
                key={index}
              />
            ))}
          </ul>
        </>
      )}
      {!showAvd ? null : (
        <>
          <h4>Avdelningens arrangemang</h4>
          <ul>
            {views.map((view, index) => (
              <MenuItem
                toggleMobileMenu={props.toggleMobileMenu}
                toggleSubmenu={props.toggleSubmenu}
                view={view}
                listtype={ListType.Avdelning}
                key={index}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
export default injectSheet(styles)(Statusmenu);
